import TraceContainer from '@components/containers/trace';
import VendorLayout from '@layouts/VendorLayout';
import { type FC } from 'react';

const VendorTrace: FC = () => (
    <VendorLayout>
        <TraceContainer asSite />
    </VendorLayout>
);

export default VendorTrace;
